// extracted by mini-css-extract-plugin
module.exports = {"content":"citation-generator-page_content__jN6cz"};